
export const paths = {
  USER_PROFILE: "/admin/users",
  USER_SETTINGS: "/user/setting",
  CREATE_ROLE: "/admin/role",
  SEARCH: "/search",
  SESSION_TRACK: "/sessionTrack",
  CATALOG_MANAGEMENT: "/catalog/allcatalog",
  CATALOG_MANAGEMENT_DISPLAYTYPE: "/catalog/displaytype",
  CATALOG_MANAGEMENT_RAILS: "/catalog/rails",
  SUBSCRIPTION_MANAGEMENT: "/subscriptionManagement",
  CONTENTS: "/content/allvideos",
  CP_CONTENTS: "/content/cloudPlayout_allvideos",
  SETTINGS: "/settings",
  PLAYER: "/player",
  INFO: "/information",
  COUNTRY: "/info/country",
  BUSINESSUNIT: "/info/businessunit",
  CREATEBUSINESSUNIT: "/createbusinessunit",
  MENU: "/menu",
  MENU_ITEM: "/menu/menuitem",
  MENU_GROUP: "/menu/menugroup",
  SUBMENU: "/menu/submenu",
  LOGIN: "/login",
  PAGENOT_FOUND: "/login",
  INFO_CONFIG: "/information/config",
  INFO_DEVICES: "/information/devices",
  CREATE_USER: "/createuser",
  LOCALLANGUAGE: "/info/locallanguage",
  PARTNER: "/content/partner",
  CAST: "/cast",
  INFO_LANGUAGES: "/information/languages",
  CONTENT_GENRE: "/content/genre",
  CONTENT_PARENTALRATING: "/content/parentalrating",
  CONTENT_TAG: "/content/tag",
  CONTENT_KEYWORD: "/content/keyword",
  CONTENT_FILTER: "/content/filter",
  STUDIO: "/content/studio",
  PRODUCTION_HOUSE: "/content/productionhouse",
  CONTENT_TYPES: "/content/contentType",
  CONTENT_SUBTYPE: "/content/contentSubtype",
  EXTERNAL_PLAYER: "/content/externalplayer",
  TRANSCODE_FILE: "/transcode",
  ADINFO: "/content/adinfo",
  DASHBOARD: "/dashboard",
  GRAPH_DASHBOARD: "/dashboard/platform&device",
  ADS_GRAPH_DASHSBOARD: "/dashboard/adAnalytics",
  IMAGE_PRESET: "/content/presetimage",
  PRESETS: "/content/videopresets",
  HOME: "/",
  MANAGE_TRANS: "/content/managetranscode",
  BULK_UPLOAD: "/content/bulkUpload",
  CURRENT_PLAYER: "/content/player",
  SESSION_DETAILS: "/sessionTrack/:sessionId",
  THEME_BUILDER: "/theme",
  MANAGE_SUB: "/content/managesubtile",
  CONTENT_DASHBOARD: "/dashboard/contentAnalytics",
  GEOGRAPHIC_DASHBOARD: "/dashboard/geographicDistribution",
  USER_DATA_DASHBOARD: "/dashboard/userData",
  PLAYBACK_ANALYTICS: "/dashboard/playbackAnalytics",
  DEVICE_PLATFORM_ANALYTICS: "/dashboard/devicePlatformAnalytics",
  SUBSCRIPTION_REVENUE_ANALYTICS: "/dashboard/subscriptionRevenueAnalytics",
  CONTENT_ANALYTICS: "/dashboard/contentAnalyticsNew",
  USER_ACTIVITY_DASHBOARD: "/dashboard/userActivity",
  UNIVERSE_ANALYTICS: "/dashboard/universeAnalytics",
  METRICS_DASHBOARD: "/metrics-dashboard",
  METRICS_CORE_ENGAGEMENT: "/metrics-dashboard/core-engagement",
  METRICS_AI_GENERATION: "/metrics-dashboard/ai-generation",
  METRICS_CONTENT_ENGAGEMENT: "/metrics-dashboard/content-engagement",
  METRICS_CREATOR_ANALYTICS: "/metrics-dashboard/creator-analytics",
  METRICS_SUBSCRIPTION_REVENUE: "/metrics-dashboard/subscription-revenue",
  METRICS_WALLET_REWARDS: "/metrics-dashboard/wallet-rewards",
  METRICS_AUTH_ONBOARDING: "/metrics-dashboard/auth-onboarding",
  METRICS_NOTIFICATIONS_REENGAGEMENT: "/metrics-dashboard/notifications-reengagement",
  EVENTS: "/events",
  EVENTS_USER_LIFECYCLE: "/events/user-lifecycle",
  EVENTS_AUTH_ONBOARDING: "/events/auth-onboarding",
  EVENTS_AI_GENERATION: "/events/ai-generation",
  EVENTS_AI_TOOL_ACTIONS: "/events/ai-tool-actions",
  EVENTS_AI_TOOLS: "/events/ai-tools",
  EVENTS_CONTENT: "/events/content",
  EVENTS_CONTENT_ENGAGEMENT: "/events/content-engagement",
  EVENTS_CREATOR: "/events/creator",
  EVENTS_DISCOVERY: "/events/discovery",
  EVENTS_SEARCH: "/events/search",
  EVENTS_EDIT_SUITE: "/events/edit-suite",
  EVENTS_SUBSCRIPTION_REVENUE: "/events/subscription-revenue",
  EVENTS_WALLET_REWARDS: "/events/wallet-rewards",
  EVENTS_NOTIFICATIONS: "/events/notifications",
  EVENTS_SETTINGS_PROFILE: "/events/settings-profile",
  EVENTS_DEVICE_PLATFORM: "/events/device-platform",
  EVENTS_DASHBOARD_NAVIGATION: "/events/dashboard-navigation",
  EVENTS_TOOL_WISE: "/events/tool-wise",
  EVENTS_OTHER_NAVIGATION: "/events/other-navigation",
};

export const superModule = {
  CMS_BACKEND: "cms-backend",
};

export const steps = [
  "Basic Information",
  "Images",
  "Detailed Metadata",
  "Rating",
  "Tags",
  "Previews",
  "Videos",
  "Transcoding",
];

export const localStorageConstants = {
  TOKEN: "token",
  USER_ID: "userId",
  YOUTUBE_TOKEN: "youtubeAuthUrl",
  PROGRESS_ID: "progressID",
  USER_NAME: "userName",
  FACEBOOK_TOKEN: "facebookAuthToken",
  X_ACCESS_TOKEN: "accessToken",
  X_ACCESS_SECRET: "accessSecret",
  FACEBOOK_USERNAME: "facebookUserName",
  YOUTUBE_USERNAME: "YoutubeUserName",
  TWITTER_USERNAME: "twitterUsername",
  TWITTER_ACCESSECRET: "accessSecret",
  TWITTER_ACCESSTOKEN: "accessToken",
  DASHBOARD_TOKEN: "dashboardToken",
  ANALYTIC_TOKEN: "analyticToken",
};

export const MENU_ITEM_HEIGHT = 48;
export const menuOptions = ["Edit"];
export const deleteOptions = ["Delete"];
export const IMAGE_BASE_URL =
  "https://logix-cms-content.s3.ap-south-1.amazonaws.com/";

export const socialPlatforms = {
  FACEBOOK: "Facebook",
  YOUTUBE: "Youtube",
  X: "X",
  INSTAGRAM: "Instagram",
};
export const socialConnectMessage = {
  message:
    "You are not connected in any Social App, If you want to upload the content to social, please connect your social first,",
  link: "click here to connect",
};
export const socialPublishErrorMessage = {
  title: "Publishing Error",
  description:
    "We encountered an error while attempting to publish your video content. Please try again. If the issue persists, contact support for assistance.",
};
export const SOCIAL_TEXT = {
  socialConnectText: "Connect your social account to get started.",
  socialCardText: "This feature will be available after the video is uploaded.",
};
export const operationConstants = {
  KEYWORD: "keyword",
};
export const RAILS = {
  RAIL_DISPLAYNAME: "Name",
  FROM_VERSION: "From Version",
  TO_VERSION: "To Version",
  RAIL_NAME: "Key",
  DISPLAY_TYPE: "Display Type",
  RAIL_TYPE: "Rail Type",
  ALERT_MESSAGE:
    "You are Trying to Create Carousel with a key which is Already Exist.",
};

export const ERROR_TITLE = "Mandatory Fields Missing";
export const ERROR_DESCRIPTION =
  "Please fill in all mandatory fields before publishing your content.";

export const ERROR_CONSTANTS = {
  requiredOverView: "Overview is Required...",
  requiredDescription: "Please provide Description...",
  requiredTagline: "Tagline is required",
  requiredTitle: "Title is required",
  warningMessage: "Ensure that you have filled all the mandatory fields!",
  errorInFeatching: "Error in Fetching Data",
};

export const button = {
  CANCEL: "Cancel",
  SAVE: "Save",
  DELETE: "Delete",
  ADD: "Add",
  UPDATE: "Update",
  REMOVE: "Remove",
  OK: "OK",
  CLOSE: "Close",
};

export const ADD_VIDEO = "Add Asset";
export const ALL_VIDEOS = "All Assets";
export const Edit_VIDEO = "Edit Asset";
export const ADD_VIDEO_OPTIONS = ["Upload File", "Publish with URL"];
export const MENU_NAMES = {
  CONTENT: "Content Hub",
};
export const TAGS = "Tags";
export const CONTENT_TYPE = "Content Types";

export const standaloneMenu = {
  STANDALONE: "Standalone Item",
  ADD_STANDALONE: "Add Standalone Item",
  EDIT_STANDALONE: "Edit Standalone Item",
  Item_Name: "Item Name",
  DISPLAY_TYPE: "Display_Type",
  NAVIGATION_TYPE: "Navigation_Type",
  SUPPORT_VERSION: "Support_Version",
  MENU_ITEM: "Menu_Item",
};
export const subMenu = {
  ADD_SUBMENU: "Add Submenu Item",
  EDIT_SUBMENU: "Edit Submenu Item",
  ITEM_NAME: "Item Name",
  INPUT_INFO: "This name will be displayed in the app.",
  DISPLAY_TYPE: "Display Type",
  NAVIGATION_TYPE: "Navigation Type",
  HOME: "Home",
  MENU_BUILDER: "Menu Builder",
  SUBMENU_ITEM: "Submenu Item",
  FROM: "From",
  To: "To",
};
export const No_Results_Found = "No Results Found";
export const DROPDOWN_MESSAGES = {
  allOptionsSelected: "You've chosen all items",
  chooseOne: "Choose One",
  chooseMultiple: "Choose one or more",
};
export const DISPLAY_TYPE = {
  ADD_DISPLAYTYPE: "Add Display Type",
  Edit_DISPLAYTYPE: "Edit Display Type",
  DISPLAYTYPE: "Display Type",
  INFO_TEXT: "This name will be displayed in the CMS for reference.",
  HOME: "Home",
  CATALOG: "Catalog",
  DISPLAY_NAME: "Display Name",
  REFRENCE_NAME: "Reference Name",
  DISPLAYNAME: "displayName",
  TAG_NAME: "Tag Name",
  CAROUSEL_NAME: "Carousel Name",
  TYPE: "Type",
  PROFILE: "Profile",
  IMAGE_URL: "Image Url",
  LAYOUT_TYPE: "Layout Type",
  NAME: "Name",
};

export const GLOBAL_TEXT = {
  LOADING: "Loading...",
  ERROR_FETCHING: "Error fetching",
};

export const NAME = "name";

export const RATING_CONSTANTS = {
  RatingLimit: "ratingLimit",
  RatingValue: "rating",
};
export const IMAGE_CONSTANTS = {
  IAMGE_REQUIRED: "Image is required",
  TYPE_REQUIRED: "Type is required",
  PROFILE_REQUIRED: "Profile is required",
};

export const isRequiredField = (
  fieldObject: object,
  PrevValCheck?: boolean
) => {
  const hasRequiredFields = Object.values(fieldObject).every(
    (field) => field !== undefined && field !== null && field !== ""
  );

  return PrevValCheck !== undefined
    ? hasRequiredFields && PrevValCheck
    : hasRequiredFields;
};

export const HOME = "Home";
export const SAVE = "Save";
export const PUBLISH = "Publish";
export const UPDATE = "Update";
export const PUBLISH_VIDEO = "Publishing Video";
export const PUBLISH_RAIL = "Publishing Rail";
export const PUBLISH_THEME = "Publishing Theme";
export const UPDATE_VIDEO = "updating Video";
export const SAVE_VIDEO = "Saving Video";
export const FIND_VIDEO = "Find Video";
export const DISCARD = "Discard";

export const IMAGES_TEXT = {
  notation: "#",
  images: "Images",
  actions: "Actions",
};
export const SOCIAL_CONNECT = {
  CONNECT: "Connect",
  LOGOUT: "Logout",
  ACTIVE_ACCOUNT: "Active Account",
};

export const CP_HEADER = {
  Id: "ID :",
  Ready_to_Publish: "Ready to Publish",
  Published: "published",
  Draft: "Draft",
  Status: "Status :",
  Duration: "Duration :",
  Content_Type: "Content Type",
  Created_On: "Created On:",
  Published_On: "Published On:",
  Copy_Code: "Copy Embed Code:",
};

export const CP_CONTENT_URL_COPY = "Copy Content URL";
export const CP_TEXT = {
  cpDetails: "Details",
  cpTitle: "Title",
  cpDescription: "Description",
  cpChannel: "Channel",
  cpLanguage: "Language",
  cpSearchTags: "Search Tags",
  cpImages: "Images",
  cpSocialConnect: "Social Connect",
  VideoFile: "Video File",
  VideoTranscodePreset: "Video Transcode Preset",
  VideoUpload: "Video Upload",
  videoPresetDrawerHeader: "View Preset Details",
  noRows: "No rows",
  notAvailable: "N/A",
  embededTitle: "Embeded Code",
  embededPlayerIdLable: "Player Name",
  embededCode: "Copy Embeded Code:",
  generateSubtitle: "Generate Subtitle",
  selectLanguage: "Select Language",
};

export const THUMBNAIL_TEXT = {
  thumbnail: "Thumbnail",
  systemGenerated: "System Generated",
  custom: "Custom",
  images: "Images",
  noImageDescription: "No image selected or uploaded",
  noImageOptionDescription:
    "The thumbnails will be available after the video is uploaded.",
  selectImage: "Select Image",
  presetText: "Choose one or more presets",
};
export const ADDITIONAL_IMAGE = {
  title: "Additional Images",
  description: "Images that are required for the app",
  buttionText: "Add New Image",
  label: "Image Preset",
};
export const VIDEO_PRESETS = {
  VIDEO_PRESETS: "Video Presets",
  TOTAL_VIDEOS: "Total Videos",
  ADD_VIDEO_PRESETS: "Add Video Preset",
  IMAGE_PRESET: "image preset",
  PRESET_NAME: "Preset name",
  PRESET_KEY: "presetkey",
  UNIQUE_VALUE_WARNING:
    "Please ensure this value is unique and not used elsewhere.",
  SEGMENT_DURATION: "Segment duration",
  ALREADY_EXIST: "The key above is already in use.",
  VARIANTS: "Variants",
  VARIANT_NAME: "Variant name",
  TYPE: "Type",
  SELECT_TYPE: "Select type",
  CODEC_PLACEHOLDER: "Codec",
  CODEC: "codec",
  VIDEO: "video",
  BITRATE: "Bitrate (kbps)",
  BITRATE_VALUE: "bitrate",
  BITRATE_PLACEHOLDER: "Bitrate",
  ASPECT_RATIO: "aspectRatio",
  ASPECT_RATIO_PLACEHOLDER: "Aspect ratio",
  RESOLUTION: "Resolution",
  FPS: "fps",
  KEY: "Key",
  FPS_PLACEHOLDER: "FPS",
  AUDIO: "audio",
  CHOOSE_ONE: "choose one",
  REMOVE: "remove",
  ENTER: "Enter",
  FORMAT: "Format",
  ADD_ROW: "Add row",
  HLS: "HLS",
  DASH: "DASH",
  CMAF: "CMAF",
  HEIGHT: "Height",
  NUMBER: "number",
  RADIO_GROUP_NAME: "radioGroup",
  WIDTH: "Width",
};

export const CONTENT_STATUS = {
  failed: 1,
  cancelled: 2,
  inprogress: 3,
  started: 3,
  waiting: 4,
  completed: 5,
};

export const PRIORITY_STATUS_TEXT = {
  normal: "normal",
  high: "high",
  low: "low",
  important: "important",
};
export const CONTENT_STATUS_TEXT = {
  failed: "failed",
  inprogress: "inprogress",
  started: "started",
  waiting: "waiting",
  completed: "completed",
  transcoding: "Transcoding...",
  transcodingFailed: "Transcoding Failed",
  published: "Published",
  draft: "Draft",
  Ready_to_Publish: "Ready to Publish",
  success: "success",
  processing: "processing",
  Processing: "Processing",
  cancelled: "cancelled",
  unpublished: "Unpublished",
};

export const MANAGE_CP_CONTENT = {
  ALL_CONTENT: "All",
  UNPUBLISHED: "Unpublished",
  DEACTIVATED: "Deactivated",
};

export const DEACTIVATE_CONTENT = {
  DEACTIVATE: "Deactivate Content",
  DEACTIVATE_CONTENT: "Are you sure you want to discard this content?",
  CONFIRM: "Yes",
  DECLINE: "No",
  Agree: "Ok",
  ERROR_CONTENT: "Something went wrong. Please Try again.",
  ACCESS_ERROR: "Permission Denied",
  CLOSE: "Close",
};

export const MANAGE_TRANS = {
  JOB_HEADER: "Manage Transcode",
  RUNNING_HEADER: "Running",
  INQUEUE_HEADER: "In Queue",
  COMPLETED: "completed",
  CANCELED: "cancelled",
  FAILED: "failed",
  INPROGRESS: "inprogress",
  WAITING: "waiting",
  INPROGRESS_LABEL: "In Progress",
  COMPLETED_LABEL: "Completed",
  FAILED_LABEL: "Failed",
  CANCELED_LABEL: "Cancelled",
};

export const MANAGE_SUBTITLE = {
  JOB_HEADER: "Manage Subtitle",

};

export const DISCARD_CONFIRM_POPUP = {
  CONTENT: "Are you sure? Your changes will not be saved.",
  HEADER: "DISCARD",
};

export const REMOVE_CONFIRM_POPUP = {
  CONTENT: "Are you sure? This action is irreversible and cannot be undone.",
  HEADER: "REMOVE VIDEO",
};

export const DELETE_WARNING = {
  HEADER: "DELETE VIDEO JOB",
  CONTENT: "Please unpublish the content before deleting this video job.",
  OK: "Ok",
};

export const PRESET_ERRORS = {
  presetErrorText: "preset values are required",
  imageErrorText: "Image file input is required",
};

export const BULK_UPLOAD = {
  BULK_UPLOAD: "Bulk Upload",
  NAME: "Name",
  CSV_FILE: "CSV File",
  CSV_DRAG_AND_DROP: "or drag & drop the file here",
  BROWSE_FILE: "Browse File",
  UPLOAD: "Upload",
  DOWNLOAD_CSV: "Download CSV Template",
  INFO_TEXT: "Only the reference name can be updated.",
  UPLOAD_CSV: "Upload CSV",
  FIND_CSV: "Find csv",
  BULK_SUBHEADER: "Transcoded Files",
  CHANGE_NAME: "Change Name",
  BACK: "Back",
};

export const OTT_JOBS = {
  ottJobs: "ottJobs",
  Video_File: "Video File",
  Upload_new_video: "Upload new video",
  RadioGroup: "radioGroup",
  Newvideo: "newvideo",
  Reuse_already_uploaded_video: "Reuse already uploaded video",
  Reusevideo: "Reusevideo",
  VideoInput_input: "VideoInput_input",
  Red: "red",
  Provide_a_link_or_URL:
    "Provide a link or URL to reuse a video from previously uploaded content.",
  Valid_URL_Characters:
    "Please ensure the URL includes only valid characters: A-Z, 0-9, -, /, ., _.",
  PresetData: "presetData",
  Quality_Group: "Quality Group",
  QualityGroup: "QualityGroup",
  Duration: "Duration",
  duration: "duration",
  Run_Time: "Run Time",
  run_Time: "runtime",
  Conten_Url: "contentUrl",
  Runtime: "Runtime",
  AD: "AD",
  LicenseURL: "LicenseURL",
  License_URL: "License URL",
  Content_URL: "Content URL",
  reuseUrl: "reuseUrl",
};

export const CONSTANTS = {
  itemsPerPage: 10,
  itemsPerMiniPage: 5,
  itemsPerMicroPage: 3,
};

export const EXTERNAL_CONSTANTS = {
  addExternalPlayerButton: "Add External Player",
  header: "External Player",
  pIdentifier: "Player Identifier",
  pKey: "Player Key",
  pName: "Player Name",
};
export const AD_INFO = {
  header: "AD Campaign",
  adButton: "Add Ad Info",
  adUrl: "Base URL",
  adProvider: "Provider Name",
  adCUPoints: "Cue points (comma separated)",
  campaignName: "Campaign Name",
  keyName: "Key",
  value: "Value",
  AD_URL: "AD URL",
  GenerateValue: "Generate Values from Base URL",
  Parameters: "Parameters",
  customParmeters: "Custom Parameters",
  ADD_ROW: "Add Row",
  MISSING_URL_ERROR: "URL is required",
  MISSING_CUEPOINT_ERROR: "CuePoints required",
  MISSING_CAMPAIN_ERROR: "Campaign Name required",
};
export enum RowType {
  PARAMETERS = "parameters",
  CUSTOM_PARAMETERS = "customParameters",
}

export const CONTENT_TYPE_PAGE = {
  ADD_CONTENT: "Add Content Type",
};

export const CONTENT_SUB_TYPE_PAGE = {
  CONTENT_SUB_TYPE: "Content Sub Type",
  ADD_SUB_CONTENT: "Add Content Sub Type",
};

export const KEYWORD_CONSTANTS = {
  ADD_KEYWORD: "Add Keyword",
  KEYWORDS: "Keywords",
};

export const BUSINESSUNIT_CONSTANTS = {
  LABELS: {
    DISPLAY_NAME: "Display Name",
    NAME: "Name",
    CURRENCY_NAME: "Currency Name",
    CURRENCY_SYMBOL: "Currency Symbol",
    SELECT_COUNTRY: "Select Country",
    TITLE: "Business Unit",
    ADD_BUSINESS_UNIT: "Add Business Unit",
  },
  ERRORS: {
    DISPLAY_NAME_REQUIRED: "Display Name is required",
    NAME_REQUIRED: "Name is required",
    CURRENCY_NAME_REQUIRED: "Currency Name is required",
    CURRENCY_SYMBOL_REQUIRED: "Please enter a valid currency symbol",
  },
  PLACEHOLDERS: {
    SELECT_COUNTRY: "Select Country",
  },
};
export const COUNTRY_CONSTANTS = {
  LABELS: {
    SHORT_NAME: "Short Name",
    IMAGE_LINK: "Image Link",
    PHONE_CODE: "Phone Code",
    TIMEZONE: "Time Zone",
    TITLE: "Country",
    ADD_COUNTRY: "Add Country",
  },
  ERRORS: {
    SHORT_NAME_REQUIRED: "Short Name is required",
    IMAGE_LINK_REQUIRED: "Image Link is required",
    PHONE_CODE_REQUIRED: "Phone Code is required",
    TIMEZONE_REQUIRED: "Time Zone is required",
  },
  TITLES: {
    CREATE: "Create Country",
    UPDATE: "Update Country",
  },
};
export const DEVICE_CONSTANTS = {
  LABELS: {
    ICON: "Icon",
    ACTIVE: "Active",
    DEVICE: "Device",
    CREATE_DEVICE: "Create Device",
  },
  ERROR_MESSAGES: {
    ICON_REQUIRED: "Icon is required",
  },
  TITLES: {
    CREATE: "Create Device",
    EDIT: "Edit Device",
  },
};
export const LANGUAGE_CONSTANTS = {
  ERRORS: {
    ALT_DISPLAY_NAME_REQUIRED: "Alternative Display Name is required",
    SHORT_CODE_REQUIRED: "Short Code is required",
    IMAGE_LINK_REQUIRED: "Image Link is required",
  },
  MODAL_TITLES: {
    CREATE: "Create Language",
    UPDATE: "Update Language",
  },
  LABELS: {
    ALT_DISPLAY_NAME: "Alternative Display Name",
    NAME: "Language Name",
    SHORT_CODE: "Short Code",
    IMAGE_LINK: "Image URL",
    TITLE: "Languages",
    ADD_LANGUAGE: " Add Language",
    LOCAL_TITLE: "Local Languages",
    ADD_LOCAL_LANGUAGE: "Add Local Languages",
  },
};

export const PLAYER = {
  header: "Player",
  addPlayer: "Add Player",
  updatePlayer: "Update Player",
  name: "Name",
  createPlayer: "Create Player",
  adCampaign: "Ad Campaign",
  playlist: "Playlist",
  autoPlay: "Auto Play",
  startOnMute: "Start on Mute",
  image: "Image",
  browseImage: "Browse Image",
  resolution: "Resolution",
  aspectRatio: "Aspect Ratio",
};

export const dateRangeOptions = [
  { key: "today", text: "Today", value: "today" },
  { key: "yesterday", text: "Yesterday", value: "yesterday" },
  { key: "last_7_days", text: "Last 7 Days", value: "last_7_days" },
  { key: "last_30_days", text: "Last 30 Days", value: "last_30_days" },
  { key: "last_month", text: "Last Month", value: "last_month" },
  { key: "last_year", text: "Last Year", value: "last_year" },
];
export const platformOptions = [
  { key: 1, text: "Web", value: "Web" },
  { key: 2, text: "Mobile", value: "Mobile" },
  { key: 2, text: "Web-app", value: "Web-app" },
];

export const DASHBOARD_FILTER_NAMES = {
  PLATFORM: "Platform",
  DURATION: "Duration",
  PLAYER: "Player",
  CONTENT: "Content",
  PARTNER: "Partner",
};

export const DAYS_SHORTHANDS = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];

export const HOURLY_SHORTHANDS = [
  "12AM", // 00:00
  "1AM", // 01:00
  "2AM", // 02:00
  "3AM", // 03:00
  "4AM", // 04:00
  "5AM", // 05:00
  "6AM", // 06:00
  "7AM", // 07:00
  "8AM", // 08:00
  "9AM", // 09:00
  "10AM", // 10:00
  "11AM", // 11:00
  "12PM", // 12:00
  "1PM", // 13:00
  "2PM", // 14:00
  "3PM", // 15:00
  "4PM", // 16:00
  "5PM", // 17:00
  "6PM", // 18:00
  "7PM", // 19:00
  "8PM", // 20:00
  "9PM", // 21:00
  "10PM", // 22:00
  "11PM", // 23:00
];

export const GRAPH_DASHBOARD_TITLES = {
  CONTENT_PLAYED: "Content Played",
  CONTENT_FAILED: "Content Failed",
  CONTENT_PLAYED_OVER_TIME: "Content Played Over Time",
  CONTENT_FAILED_OVER_TIME: "Content Failed Over Time",
  CONTENT_TOTAL_VIEWS: "totalViews",
  CONTENT_FAILED_CONTENTS: "failedContents",
  COMBINED_AD_METRICS: "AD Metrics",
  CONTENT_OVERVIEW: "Content Overview",
};

export const AD_GRAPH_TITLES = {
  CLICK_THROUGH_RATE: "clickThroughRate",
  COMPLETION_RATE: "completionRate",
  CONVERSION_RATE: "conversionRate",
  FAILED_ADS: "failedAds",
  FREQUENCY: "frequency",
  REACH: "reach",
  SUCCESSFULL_ADS: "successfulAds",
  TOTAL_CLICKS: "totalClicks",
  TOTAL_IMPRESSIONS: "totalImpressions",
  AD_TOTAL_IMPRESSIONS: "Total Ad Impressions",
  AD_TOTAL_CLICKS: "Total Ad Clicks",
  AD_REACH: "Ad Reach",
  COMBINED_AD_METRICS: "AD Metrics",
  CONTENT_METRICS: "Content Metrics"
};
export const BRAND_COLORS = [
  "#4285F4",
  "#FF597A",
  "#FFD550",
  "#19FA19",
  "#0999F1",
  "#AECBFA",
  "#D2E3FC",
];
